/**
 * Created by Fernando Torres on 17/11/2017.
 */

export default {
  model: function () {
    return {
      password: ''
    }
  },
  rules: {
    model: {
      password: {
        required: true,
        message: 'El password es requerido'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/login-activate.model.js